import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { updateUserPassword, cancelUpdate } from '../../actions/customerPortal';
import { storeWithExpiration } from '../../utils/common';
import UpdatePasswordForm from './UpdatePasswordForm';
import { ONE_UPPERCASE_ONE_LOWERCASE_REGEX, ONE_NUMBER_REGEX } from '../../config/app_config';

const FORM_ID = 'updatePasswordForm';

export class UpdatePassword extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateUserPasswordAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  performPasswordUpdate = params => {
    const { updateUserPasswordAction, user } = this.props;
    const token = storeWithExpiration.get('token');
    const body = {
      userId: user.get('id'),
      currentPlainTextPassword: params.password,
      newPlainTextPassword: params.newPassword,
    };

    updateUserPasswordAction(body, token);
  };

  render() {
    const { invalid, handleSubmit, submitting } = this.props;

    return (
      <UpdatePasswordForm
        invalid={invalid}
        handleSubmit={handleSubmit}
        updatePasswordFunction={this.performPasswordUpdate}
        submitting={submitting}
      />
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.password || values.password === '') {
    errors.password = 'Required';
  }
  if (!values.confirmPassword || values.confirmPassword === '') {
    errors.confirmPassword = 'Required';
  }
  if (!values.newPassword || values.newPassword === '') {
    errors.newPassword = 'Required';
  } else if (values.newPassword.length < 8) {
    errors.newPassword = 'Must Be 8 Characters or More';
  } else if (values.newPassword !== values.confirmPassword) {
    errors.newPassword = 'Passwords must match';
    errors.confirmPassword = 'Passwords must match';
  } else if (!values.newPassword.match(ONE_UPPERCASE_ONE_LOWERCASE_REGEX)) {
    errors.newPassword = 'Must contain at least one uppercase and lowercase letter';
  } else if (!values.newPassword.match(ONE_NUMBER_REGEX)) {
    errors.newPassword = 'Must contain at least one number';
  }

  return errors;
};

const UpdatePasswordRF = reduxForm({
  form: FORM_ID,
  validate,
})(UpdatePassword);

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps, {
  cancelPasswordUpdateAction: cancelUpdate,
  updateUserPasswordAction: updateUserPassword,
})(UpdatePasswordRF);
